"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.strategy = void 0;
const web3_1 = __importDefault(require("web3"));
const erc20_abi_1 = require("../../abi/erc20.abi");
const messageHelper_1 = require("../helpers/messageHelper");
const web3Factory_1 = require("../helpers/web3Factory");
const required_1 = require("../../helpers/required/required");
const lodash_1 = require("lodash");
const sumBN_1 = require("../helpers/sumBN/sumBN");
const abbreviateHelper_1 = require("../../helpers/abbreviateNumberHelper/abbreviateHelper");
const getSymbolAndName_1 = require("../helpers/getSymbolAndName");
const getBalancesOfFromChain = (token, addresses) => __awaiter(void 0, void 0, void 0, function* () {
    const { address: ERC20Address, chainId } = token;
    required_1.requiredDefined(ERC20Address, 'address of token is required');
    required_1.requiredDefined(chainId, 'chainId of token is required');
    const web3Provider = yield web3Factory_1.web3Factory(chainId);
    const erc20SmartContracts = new web3Provider.eth.Contract(erc20_abi_1.erc20ABI, ERC20Address);
    required_1.requiredType(addresses, 'array', 'addresses has to an array');
    return yield Promise.all(addresses.map(address => {
        return erc20SmartContracts.methods.balanceOf(address).call()
            .then(balanceOf => ({
            address,
            balanceOf,
            chainId
        }));
    }));
});
const getBalancesOfChains = (strategy, decimals) => __awaiter(void 0, void 0, void 0, function* () {
    const { addresses, params } = strategy;
    const balances = yield Promise.all(params.tokens
        .map(param => getBalancesOfFromChain(param, addresses)));
    const flatBalances = lodash_1.flattenDeep(balances);
    const sumWithDecimals = sumBN_1.sumBN(flatBalances.map(d => d.balanceOf));
    const abbreviatedSum = abbreviateHelper_1.abbreviateTokenBN(sumWithDecimals, decimals);
    return {
        decimals,
        sumWithDecimals: abbreviatedSum.withDecimals,
        sum: abbreviatedSum.abbreviated,
        balances: flatBalances
    };
});
const getImageUrl = (token, chainId) => {
    required_1.requiredType(chainId, 'string', 'chainId should be a string');
    required_1.requiredType(chainId, 'string', 'token should be a string');
    const chainName = chainId === '1' ? 'ethereum' : 'polygon';
    return `https://storage.googleapis.com/zapper-fi-assets/tokens/${chainName}/${token.toLowerCase()}.png`;
};
const getEnrichedInformation = (strategy) => __awaiter(void 0, void 0, void 0, function* () {
    const tokenOnChain = strategy.params.tokens.find(d => d.chainId === '1' || d.chainId === '137');
    const isErc20Token = strategy.name.includes('erc-20');
    const logo = strategy.logo ? strategy.logo : isErc20Token && tokenOnChain ? getImageUrl(tokenOnChain.address, tokenOnChain.chainId) : 'https://raw.githubusercontent.com/Arianee/spkz-metadata/main/assets/default-icon.png';
    const firstToken = strategy.params.tokens[0];
    const { decimals, symbol, name } = yield getSymbolAndName_1.getNameAdSymbolAndDecimalsERC20({
        address: firstToken.address,
        chainId: firstToken.chainId
    });
    return {
        logo,
        symbol,
        name,
        acquireURLs: strategy.acquireURLs
    };
});
exports.strategy = (strategy) => __awaiter(void 0, void 0, void 0, function* () {
    const { params } = strategy;
    const { decimals, symbol } = yield getSymbolAndName_1.getNameAdSymbolAndDecimalsERC20(params.tokens[0]);
    const balances = yield getBalancesOfChains(strategy, decimals);
    const amount = web3_1.default.utils.toBN(balances.sumWithDecimals);
    const minAmount = web3_1.default.utils.toBN(params.minBalance);
    const isAuthorized = amount.gte(minAmount);
    const message = messageHelper_1.minMaxMessage({
        symbol,
        decimals,
        balance: balances.sumWithDecimals,
        amountRequired: params.minBalance
    });
    const minBalanceAbbreviated = abbreviateHelper_1.abbreviateTokenBN(params.minBalance, decimals);
    const details = Object.assign(Object.assign({}, balances), { minBalance: minBalanceAbbreviated.abbreviated, minBalanceWithDecimals: minBalanceAbbreviated.withoutDecimals });
    const code = isAuthorized ? 0 /* SUCCESS */ : 1 /* NOTENOUGH */;
    const enrichedInformations = yield getEnrichedInformation(strategy);
    return {
        isAuthorized,
        strategy: strategy,
        message: message,
        code,
        details,
        enrichedInformations
    };
});
//# sourceMappingURL=index.js.map